<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
   <ChurchNavbar v-if="$store.state.auth.user_status_id==2"></ChurchNavbar> 
   <AdminNavbar v-if="$store.state.auth.user_status_id==1"></AdminNavbar>
   
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import ChurchNavbar from './ChurchNavbar.vue'; 
  import AdminNavbar from './AdminNavbar.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      ChurchNavbar,    
      AdminNavbar,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      }
     
    },
    mounted() {
     
    }
  };
</script>
<style lang="scss">
</style>
